export default "__VITE_PUBLIC_ASSET__54b9f40a__"